import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

import { IJourneySessionProgress } from '../interfaces/journey.interface';

@Injectable({ providedIn: 'root' })
export class JourneyService {
	servicesUrl = environment.servicesUrl;

	constructor(private httpClient: HttpClient) {}

	getOverview(customerId) {
		return this.httpClient.get<any>(
			`${this.servicesUrl}/journeys/screening/office/${customerId}/overview`
		);
	}

	getUserScreening(customerId: string) {
		return this.httpClient.get<any>(
			`${this.servicesUrl}/journeys/screenings/${customerId}`
		);
	}

	getJourneySessionProgress(
		profileId: string,
		sessionId: string
	): Observable<IJourneySessionProgress> {
		return this.httpClient.get<IJourneySessionProgress>(
			`${this.servicesUrl}/journeys/screenings/journey/user/${profileId}/session/${sessionId}/progress`
		);
	}
}
